<template>
    <div class="form-group">
        <label class="placeholder-label" For="phone">{{ labelName }}&nbsp;*</label>
        <MazPhoneNumberInput
            default-country-code="CZ"
            v-model="phoneNumber"
            @update="results = $event"
            @change="updatePhoneNumber()"
            :error="results === null || results.phoneNumber === null ? false : !results.isValid"
            :translations="{
                countrySelectorLabel: 'Kód země',
                countrySelectorError: 'Vyberte zemi',
                phoneNumberLabel: 'Telefonní číslo',
                example: 'Například: '
            }"
            required
        />
        <input name="phone" hidden id="phone-number-register" required>
    </div>
</template>
<script>
import MazPhoneNumberInput from "maz-ui/lib/maz-phone-number-input";
// import "maz-ui/lib/css/base.css";
// import "maz-ui/lib/css/maz-phone-number-input.css";

export default {
    components: {
        MazPhoneNumberInput
    },
    props: {
        labelName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            phoneNumber: null,
            results: null,
        }
    },
    watch: {
        'results'() {
            this.updatePhoneNumber();
        }
    },
    methods: {
        updatePhoneNumber() {
            if (this.results?.isValid) {
                document.getElementById('phone-number-register').value = this.phoneNumber;
            } else {
                document.getElementById('phone-number-register').value = '';
            }
        }
    }
}
</script>
